import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsPercentageSelectorComponent } from "./ds-percentage-selector.component";
import { DsIconModule } from "../ds-icon/ds-icon.module";
@NgModule({
  declarations: [DsPercentageSelectorComponent],
  imports: [CommonModule, DsIconModule],
  exports: [DsPercentageSelectorComponent],
})
export class DsPercentageSelectorModule {}
